import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
    { path: '/work-with-me', label: 'Work With Me' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <div className={`text-2xl font-light tracking-tight transition-colors duration-300 font-serif ${
              isScrolled ? 'text-charcoal-900' : 'text-white'
            }`}>
              Alchemy of Polarity
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm tracking-wide uppercase transition-colors duration-300 ${
                  location.pathname === link.path
                    ? isScrolled ? 'text-mauve-400 font-semibold' : 'text-white font-semibold'
                    : isScrolled ? 'text-charcoal-700 hover:text-mauve-400' : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
            
            <a
              href="https://calendly.com/alchemyofpolarity"
              target="_blank"
              rel="noopener noreferrer"
              className={`px-6 sm:px-8 py-3 text-sm tracking-wide sm:tracking-widest uppercase font-semibold rounded-lg transition-all duration-300 cursor-pointer ${
                isScrolled 
                  ? 'bg-mauve-400 text-white hover:bg-mauve-500 shadow-md hover:shadow-lg' 
                  : 'bg-white/10 backdrop-blur-sm border border-white/30 text-white hover:bg-white/20'
              }`}
            >
              Book Call
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center ${
              isScrolled ? 'text-charcoal-900' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-6 pb-6 border-t border-cream-200 pt-6 bg-white rounded-xl shadow-xl">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`px-4 py-3 text-sm tracking-wide uppercase transition-colors duration-300 ${
                    location.pathname === link.path
                      ? 'text-mauve-400 font-semibold bg-mauve-400/10 rounded-lg'
                      : 'text-charcoal-700 hover:text-mauve-400 hover:bg-cream-100 rounded-lg'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              
              <a
                href="https://calendly.com/alchemyofpolarity"
                target="_blank"
                rel="noopener noreferrer"
                className="mx-4 mt-2 px-6 py-4 bg-mauve-400 text-white text-sm tracking-wide uppercase hover:bg-mauve-500 transition-all duration-300 cursor-pointer font-semibold rounded-lg text-center shadow-md"
              >
                Book Call
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
